import React from "react";
import { Outlet } from "react-router-dom";

const BlankLayout = () => {
  return <Outlet />; // Samo sadržaj, bez Navbar i Footer
};

export default BlankLayout;